import { CdoToAllDisMap, CollectedKycDataOption } from '@onefootprint/types';
import type { EntityVault } from '@/types/vault';

const hasLegalStatus = (vault: EntityVault | undefined) => {
  const vaultDIs = Object.keys(vault || {});
  const legalStatusDIs = CdoToAllDisMap[CollectedKycDataOption.usLegalStatus];
  return vaultDIs.some(di =>
    // @ts-expect-error migrate this to the new CDO
    legalStatusDIs.includes(di),
  );
};

export default hasLegalStatus;
